export const PathUtils = {
  strip: (path: any) => {
    if (path.startsWith("/")) path = path.slice(1)
    if (path.endsWith("/")) path = path.slice(0, -1)

    return path
  },

  toPageUri: (path: any) => PathUtils.strip(path) || "home",
  checkUri: (path: any) => {
    if (path.startsWith("/")) return path
    return `/${path}`
  },
}
